import { FormBase } from 'core/components';

export default class DuplicateReportForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'name',
					label: 'REPORTS.NAME',
					rules: 'required',
				},
			],
		};
	}
}
